// extracted by mini-css-extract-plugin
export default {"container":"DZ-z","list":"EZ-z"};